// Define action types
export const SET_SELECTED_TEAM = 'SET_SELECTED_TEAM';

// Action creator
export const setSelectedTeam = (team: any) => ({
    type: SET_SELECTED_TEAM,
    payload: team,
});
